import React, { useEffect } from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { useTranslation } from "react-i18next";
type LoanCalculatorProps = RouteComponentProps<{}>;

const LoanCalculator: React.FunctionComponent<LoanCalculatorProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12">
                    <h1 className="title-page">{tLang("resourcesSection.calculator.label.loanComparisonCalculator")}</h1>
                </div>
            </div>

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="table-container scroll">
                            <div id="calc-body">
                                <div id="container_outer">
                                    <div>
                                        <Link id="close" to="/resources/calculators">
                                            X
                                        </Link>
                                    </div>

                                    <div className="calc_container">
                                        <div className="calc_contents">
                                            <div className="calc_description">
                                                <h3 className="financial" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                                                    <strong>Loan Comparison Calculator</strong>
                                                </h3>
                                                <p>
                                                    <strong>
                                                        This calculator will calculate the monthly payment and interest costs for up to four loans-all on one screen
                                                        for comparison purposes.
                                                    </strong>
                                                </p>
                                                <p>
                                                    To calculate the payment amount and the total interest of any fixed term loan, simply fill in the 3 left-hand
                                                    cells of the first row and then click on "Compute." Use the other three rows to see what effects are produced by
                                                    changing any one of the loan's original variables.
                                                </p>
                                            </div>

                                            <table className="calculator mort">
                                                <tbody>
                                                    <tr>
                                                    <th><strong> <label htmlFor="principal-1"interest-1> Principal </label></strong></th>
                                                    <th><strong><label htmlFor="interest-1"> Interest <br/> Rate </label></strong></th>
                                                    <th><strong><label htmlFor="numPmts-1"># of <br/>Payments </label></strong>
                                                    </th>

                                                    <th></th>
                                                    <th><strong>  <label htmlFor="payment-1">Monthly <br /> Payment</label></strong> </th>
                                                     <th> <strong><label htmlFor="totalint-1">Total<br/>Interest</label></strong> </th>
                                                     
                                                        <th></th>
                                                        
                                                    </tr>

                                                 
                                                   


                                                    <tr>
                                                        <td>
                                                            {" "}
                                                            <input type="text" id="principal-1" aria-labelledby="principal-1" name="principal1" className="med" />
                                                        </td>
                                                        <td>
                                                            <input type="text" id="interest-1" aria-labelledby="interest-1" name="interest" className="sm" />
                                                        </td>
                                                        <td>
                                                            <input type="text" id="numPmts-1" aria-labelledby="numPmts-1" name="numPmts" className="sm" />
                                                        </td>
                                                        <td>
                                                            <input
                                                                className="debt_textbtn"
                                                                id="btnCompute-1"
                                                                type="button"
                                                                value="Compute"
                                                                onClick={() =>
                                                                    window.computeLoan("principal-1", "interest-1", "numPmts-1", "payment-1", "totalint-1")
                                                                }
                                                                style={{ width: "85px" }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input type="text" id="payment-1" aria-labelledby="payment-1" name="payment" className="med" />
                                                        </td>
                                                        <td>
                                                            <input type="text" id="totalint-1" aria-labelledby="totalint-1" name="totalint" className="med" />
                                                        </td>
                                                        <td>
                                                            <input
                                                                className="debt_textbtn"
                                                                id="btnReset-1"
                                                                type="button"
                                                                value="Reset"
                                                                onClick={() =>
                                                                    window.resetLoan("principal-1", "interest-1", "numPmts-1", "payment-1", "totalint-1")
                                                                }
                                                                style={{ width: "62px" }}
                                                            />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th><strong> <label htmlFor="principal-2"> Principal <span className="hide-label"> &nbsp;</span></label></strong></th>
                                                        <th><strong><label htmlFor="interest-2"> Interest <br /> Rate <span className="hide-label"> &nbsp;</span></label></strong></th>
                                                        <th><strong><label htmlFor="numPmts-2"># of <br />Payments <span className="hide-label"> &nbsp;</span></label></strong>
                                                        </th>

                                                        <th></th>
                                                        <th><strong>  <label htmlFor="payment-2">Monthly <br /> Payment <span className="hide-label"> &nbsp;</span></label></strong> </th>
                                                        <th> <strong><label htmlFor="totalint-2">Total<br />Interest <span className="hide-label"> &nbsp;</span></label></strong> </th>

                                                        <th></th>

                                                    </tr>

                                                        <tr><td><input type="text" id="principal-2" aria-labelledby="principal-2" name="principal2" className="med" /></td>
                                                            <td><input type="text" id="interest-2" aria-labelledby="interest-2" name="interest" className="sm" /></td>
                                                            <td><input type="text" id="numPmts-2" aria-labelledby="numPmts-2" name="numPmts" className="sm" /></td>
                                                            <td>
                                                                <input className="debt_textbtn" id="btnCompute-2" type="button" value="Compute " onClick={() => window.computeLoan('principal-2', 'interest-2', 'numPmts-2', 'payment-2', 'totalint-2')} style={{ width: "85px" }} /></td>

                                                            <td>
                                                                <input type="text" id="payment-2" aria-labelledby="payment-2" name="payment" className="med" />
                                                            </td>
                                                            <td>
                                                                <input type="text" id="totalint-2" aria-labelledby="totalint-2" name="totalint" className="med" />
                                                            </td>
                                                            <td>
                                                                <input className="debt_textbtn" id="btnReset-2" type="button" value="Reset " onClick={() => window.resetLoan('principal-2', 'interest-2', 'numPmts-2', 'payment-2', 'totalint-2')} style={{ width: "62px" }} />
                                                            </td>
                                                        </tr>
                                                    <tr>
                                                        <th><strong> <label htmlFor="principal-3" interest-1> Principal <span className="hide-label"> &nbsp; &nbsp;</span> </label></strong></th>
                                                        <th><strong><label htmlFor="interest-3"> Interest <br /> Rate <span className="hide-label"> &nbsp; &nbsp;</span> </label></strong></th>
                                                        <th><strong><label htmlFor="numPmts-3"># of <br />Payments <span className="hide-label"> &nbsp; &nbsp;</span></label></strong>
                                                        </th>

                                                        <th></th>
                                                        <th><strong>  <label htmlFor="payment-3">Monthly <br /> Payment <span className="hide-label"> &nbsp; &nbsp;</span></label></strong> </th>
                                                        <th> <strong><label htmlFor="totalint-3">Total<br />Interest <span className="hide-label"> &nbsp; &nbsp; </span></label></strong> </th>

                                                        <th></th>

                                                    </tr>

                                                    <tr><td><input type="text" id="principal-3" aria-labelledby="principal-3" name="principal" className="med" /></td>
                                                        <td><input type="text" id="interest-3" aria-labelledby="interest-3" name="interest" className="sm" /></td>
                                                        <td><input type="text" id="numPmts-3" aria-labelledby="numPmts-3" name="numPmts" className="sm" /></td>
                                                        <td>
                                                            <input className="debt_textbtn" id="btnCompute-3"  type="button" value=" Compute" onClick={() => window.computeLoan('principal-3', 'interest-3', 'numPmts-3', 'payment-3', 'totalint-3')} style={{ width: "85px" }} /></td>

                                                        <td>
                                                            <input type="text" id="payment-3" aria-labelledby="payment-3" name="payment" className="med" />
                                                        </td>
                                                        <td>
                                                            <input type="text" id="totalint-3" aria-labelledby="totalint-3" name="totalint" className="med" />
                                                        </td>
                                                        <td>
                                                            <input className="debt_textbtn" id="btnReset-3" type="button" value=" Reset" onClick={() => window.resetLoan('principal-3', 'interest-3', 'numPmts-3', 'payment-3', 'totalint-3')} style={{ width: "62px" }} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th><strong> <label htmlFor="principal-4" interest-1> Principal <span className="hide-label"> &nbsp; &nbsp; &nbsp;</span></label></strong></th>
                                                        <th><strong><label htmlFor="interest-4"> Interest <br /> Rate  <span className="hide-label"> &nbsp; &nbsp; &nbsp;</span></label></strong></th>
                                                        <th><strong><label htmlFor="numPmts-4"># of <br />Payments <span className="hide-label"> &nbsp; &nbsp; &nbsp;</span></label></strong>
                                                        </th>

                                                        <th></th>
                                                        <th><strong>  <label htmlFor="payment-4">Monthly <br /> Payment  <span className="hide-label"> &nbsp; &nbsp; &nbsp;</span></label></strong> </th>
                                                        <th> <strong><label htmlFor="totalint-4">Total<br />Interest  <span className="hide-label"> &nbsp; &nbsp; &nbsp;</span></label></strong> </th>

                                                        <th></th>

                                                    </tr>

                                                    <tr><td><input type="text" id="principal-4" name="principal" className="med" /></td>
                                                        <td><input type="text" id="interest-4" name="interest" className="sm" /></td>
                                                        <td><input type="text" id="numPmts-4"name="numPmts" className="sm" /></td>
                                                        <td>
                                                            <input className="debt_textbtn" id="btnCompute-4" type="button" value=" Compute " onClick={() => window.computeLoan('principal-4', 'interest-4', 'numPmts-4', 'payment-4', 'totalint-4')} style={{ width: "85px" }} /></td>

                                                        <td>
                                                            <input type="text" id="payment-4" name="payment" className="med" />
                                                        </td>
                                                        <td>
                                                            <input type="text" id="totalint-4" name="totalint" className="med" />
                                                        </td>
                                                        <td>
                                                            
                                                            <input className="debt_textbtn" id="btnReset-4" type="button" value=" Reset " onClick={() => window.resetLoan('principal-4', 'interest-4', 'numPmts-4', 'payment-4', 'totalint-4')} style={{ width: "62px" }} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Helmet>
                <script src="js/LoanCalculator.js" type="text/javascript" />
            </Helmet>
        </React.Fragment>
    );
}
export default LoanCalculator;
